<template>
<div
	data-component="MessageBar.vue"
	class="bg-[#fef8fa] p-3"
	:class="[ScreenSize > 1 ? 'shadow-elevation-y-2px' : 'shadow-elevation-y-1px', typeClass.container]"
>
	<div class="container mx-auto">
		<div class="lg:flex items-center">
			<div class="flex mr-auto">
				<BaseIcon
					:name="typeClass.icon" :size="1" class="shrink-0 mr-3 relative top-1 lg:scale-125"
					:class="typeClass.iconColor || typeClass.text"
				/>
				<div class="leading-snug flex flex-col lg:block mr-1">
					<span class="font-bold text-sm lg:text-base mr-1">
						{{ messageTitle }}
					</span>
					<span class="mt-1 text-xs lg:text-base">
						{{ messageContent }}
					</span>
				</div>
			</div>
			<div class="text-right flex mt-4 lg:mt-0 lg:flex-row-reverse whitespace-nowrap">
				<button
					class="btn btn-small text-sm w-full"
					:class="[ScreenSize <= 1 ? 'justify-end' : '', typeClass.button]"
					@click="messageButtonAction"
				>
					{{ messageButtonContent }}
				</button>
			</div>
		</div>
	</div>
</div>
</template>

<script lang="ts">

/**
* Komponent odpowiedzialny za wyświetlanie komunikatów na belce
*/
export default {
	name: 'MessageBar',
	props: {
		messageTitle: {
			type: String,
			required: true,
		},
		messageContent: {
			type: String,
			required: true,
		},
		messageType: {
			type: String as () => 'success' | 'danger' | 'alert' | 'info',
			required: true,
		},
		messageButtonContent: {
			type: String,
			required: false,
			default: 'Rozumiem',
		},
	},
	emits: ['message-button-action'],
	computed: {
		/** Style belki */
		typeClass() {
			switch (this.messageType) {
			case 'success':
				return {
					icon: 'notification-success',
					container: 'bg-[#FAFDFC] border-success',
					text: 'text-success',
					button: 'btn-success',
				};
			case 'danger':
				return {
					icon: 'notification-danger',
					container: 'bg-[#FEFBFA] border-danger',
					text: 'text-danger',
					button: 'btn-danger',
				};
			case 'alert':
				return {
					icon: 'notification-alert',
					iconColor: 'text-warn',
					container: 'bg-[#FFFCFA] border-accent',
					text: 'text-accent',
					button: 'btn-accent',
				};
			case 'info':
			default:
				return {
					icon: 'notification-info',
					container: 'border-info',
					text: 'text-info',
					button: 'text-info',
				};
			}
		},
	},
	methods: {
		messageButtonAction() {
			this.$emit('message-button-action');
		},
	},
};
</script>
